module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/brag/brag-02-5672da0b579f818b849c5a7723b74bb6.jpg";